// all home component json mocks goes in this file..
import choithramsSliderOne from '../../assets/images/home-assets/choithramsSliderOne/choithramsSliderOne.png';
import choithramsSliderTwo from '../../assets/images/home-assets/choithramsSliderTwo/choithramsSliderTwo.jpg';

import choithramsBuglesL from '../../assets/images/home-assets/choithramsBugles/choithramsBuglesL.png';
import choithramsDairyMilkL from '../../assets/images/home-assets/choithramsDairyMilk/choithramsDairyMilkL.png';

import choithramsLayerOne from '../../assets/images/home-assets/choithramsLayerOne/choithramsLayerOne.png';
import choithramsLayerTwo from '../../assets/images/home-assets/choithramsLayerTwo/choithramsLayerTwo.png';
import choithramsLayerThree from '../../assets/images/home-assets/choithramsLayerThree/choithramsLayerThree.png';
import choithramsLayerFour from '../../assets/images/home-assets/choithramsLayerFour/choithramsLayerFour.png';

import choithramsAashirvaadS from '../../assets/images/home-assets/choithramsAashirvaad/choithramsAashirvaadS.png';
import choithramsAlmondsS from '../../assets/images/home-assets/choithramsAlmonds/choithramsAlmondsS.png';
import choithramsChickenMeatBallsS from '../../assets/images/home-assets/choithramsChickenMeatBalls/choithramsChickenMeatBallsS.png';
import choithramsCornFlakesS from '../../assets/images/home-assets/choithramsCornFlakes/choithramsCornFlakesS.png';
import choithramsFaceCreamS from '../../assets/images/home-assets/choithramsFaceCream/choithramsFaceCreamS.png';
import choithramsHairCareS from '../../assets/images/home-assets/choithramsHairCare/choithramsHairCareS.png';
import choithramsJohnsonBabyS from '../../assets/images/home-assets/choithramsJohnsonBaby/choithramsJohnsonBabyS.png';
import choithramsMadhurS from '../../assets/images/home-assets/choithramsMadhur/choithramsMadhurS.png';
import choithramsOrangeS from '../../assets/images/home-assets/choithramsOrange/choithramsOrangeS.png';
import choithramsPetFoodS from '../../assets/images/home-assets/choithramsPetFood/choithramsPetFoodS.png';
import choithramsSafolaS from '../../assets/images/home-assets/choithramsSafola/choithramsSafolaS.png';
import choithramsTataSaltS from '../../assets/images/home-assets/choithramsTataSalt/choithramsTataSaltS.png';

import choithramsOrganic from '../../assets/images/home-assets/choithramsOrganic/choithramsOrganic.png';
import choithramsVegan from '../../assets/images/home-assets/choithramsVegan/choithramsVegan.png';
import choithramsVegetarianism from '../../assets/images/home-assets/choithramsVegetarianism/choithramsVegetarianism.png';
import choithramsKetogenic from '../../assets/images/home-assets/choithramsKetogenic/choithramsKetogenic.png';

import choithramsRanaBrand from '../../assets/images/home-assets/choithramsRanaBrand/choithramsRanaBrand.png';
import choithramsSimplyOrganicBrand from '../../assets/images/home-assets/choithramsSimplyOrganicBrand/choithramsSimplyOrganicBrand.jpg';
import choithramsLaysBrand from '../../assets/images/home-assets/choithramsLaysBrand/choithramsLaysBrand.jpg';
import choithramsOreoBrand from '../../assets/images/home-assets/choithramsOreoBrand/choithramsOreoBrand.jpg';

export const filterBarOptions = [
    {
        id: 1,
        title: 'DailyDeals'
    },
    {
        id: 2,
        title: 'Featured'
    },
    {
        id: 3,
        title: 'Highlights'
    },
    {
        id: 4,
        title: 'Offer Zone'
    },
    {
        id: 5,
        title: 'Top Seller'
    },
    {
        id: 6,
        title: 'Categories'
    },
    {
        id: 7,
        title: 'Related Recipes'
    },
    {
        id: 8,
        title: 'Food Style'
    },
    {
        id: 9,
        title: 'Get Free'
    },
    {
        id: 10,
        title: 'Brand'
    },
    {
        id: 11,
        title: 'Save Max'
    }
];

export const wishlistFilterBarOptions = [
    {
        id: 1,
        title: 'Wishlist'
    },{
        id: 2,
        title: 'Favourite Recipe List'
    },{
        id: 3,
        title: 'Favourite Recipes Videos'
    },{
        id: 4,
        title: 'Any New Added List'
    }
];

export const sliderItems = [
    choithramsSliderOne,
    choithramsSliderTwo,
    choithramsSliderOne,
    choithramsSliderOne
];

export const featuredItems = [
    {
        image: choithramsDairyMilkL
    },{
        image: choithramsBuglesL
    }, {
        image: choithramsDairyMilkL
    },{
        image: choithramsBuglesL
    }
];

export const offerZoneItems = [
    {
        image: choithramsLayerOne
    },{
        image: choithramsLayerTwo
    },{
        image: choithramsLayerThree
    },{
        image: choithramsLayerFour
    },{
        image: choithramsLayerOne
    },{
        image: choithramsLayerTwo
    },{
        image: choithramsLayerThree
    },{
        image: choithramsLayerFour
    }
];

export const topCategoriesItems = [
    {
        image: choithramsAashirvaadS,
        title: 'Daily Fresh'
    },
    {
        image: choithramsAlmondsS,
        title: 'Cooking & Ingredients'
    },
    {
        image: choithramsChickenMeatBallsS,
        title: 'Beverages'
    },
    {
        image: choithramsCornFlakesS,
        title: 'Household Needs'
    },
    {
        image: choithramsFaceCreamS,
        title: 'Personal Care'
    },
    {
        image: choithramsHairCareS,
        title: 'Baby & Kids'
    },
    {
        image: choithramsJohnsonBabyS,
        title: 'Bread & Dairy'
    },
    {
        image: choithramsMadhurS,
        title: 'Breakfast & Snacking'
    },
    {
        image: choithramsOrangeS,
        title: 'Household'
    },
    {
        image: choithramsPetFoodS,
        title: 'Pet Food'
    },
    {
        image: choithramsSafolaS,
        title: 'Bread & Dairy'
    },
    {
        image: choithramsTataSaltS,
        title: 'Ready To Cook'
    }
];

export const foodStyleItems = [
    {
        image: choithramsOrganic,
        title: 'Organic'
    },{
        image: choithramsVegan,
        title: 'Vegan'
    },{
        image: choithramsVegetarianism,
        title: 'Vegetarianism'
    },{
        image: choithramsKetogenic,
        title: 'Ketogenic'
    },{
        image: choithramsOrganic,
        title: 'Organic'
    },{
        image: choithramsVegan,
        title: 'Vegan'
    },{
        image: choithramsVegetarianism,
        title: 'Vegetarianism'
    },{
        image: choithramsKetogenic,
        title: 'Ketogenic'
    }
];

export const shopByBrandItems = [
    {
        image: choithramsRanaBrand
    },
    {
        image: choithramsSimplyOrganicBrand
    },
    {
        image: choithramsLaysBrand
    },
    {
        image: choithramsOreoBrand
    },
    {
        image: choithramsRanaBrand
    },
    {
        image: choithramsSimplyOrganicBrand
    },
    {
        image: choithramsLaysBrand
    },
    {
        image: choithramsOreoBrand
    }
];
